/** Target folder within the project for slot core files */
export const SLOT_CORE_DEST_FOLDER = 'slot-core';

/** Default git ref to download */
export const SLOT_CORE_DEFAULT_REF = 'main';

/** Version marker file within the slot core folder */
export const SLOT_CORE_VERSION_FILE = '.version';
